import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation()

    useLayoutEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    

    }, [pathname])

    return null
}

export default ScrollToTop
